import { render, staticRenderFns } from "./PageUnderDevelopment.vue?vue&type=template&id=429338f3&scoped=true&lang=html"
import script from "./PageUnderDevelopment.vue?vue&type=script&lang=js"
export * from "./PageUnderDevelopment.vue?vue&type=script&lang=js"
import style0 from "./PageUnderDevelopment.vue?vue&type=style&index=0&id=429338f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429338f3",
  null
  
)

export default component.exports